import Http from './base';
import { BASE_URL, MY_FAVORITES } from './base/constants';

class MyFavoritesService {
  get({ page = 1 }) {
    return Http.get(`${BASE_URL}${MY_FAVORITES}`, {
      params: { page: page - 1 }
    });
  }

  delete({ id }) {
    return Http.delete(`${BASE_URL}${MY_FAVORITES}/${id}`);
  }
}

export default new MyFavoritesService();
